import { render, staticRenderFns } from "./PaymentRegistration.vue?vue&type=template&id=b7b87974&scoped=true&"
import script from "./PaymentRegistration.vue?vue&type=script&lang=js&"
export * from "./PaymentRegistration.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRegistration.vue?vue&type=style&index=0&id=b7b87974&prod&scoped=true&lang=css&"
import style1 from "./PaymentRegistration.vue?vue&type=style&index=1&id=b7b87974&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b87974",
  null
  
)

export default component.exports